import React from 'react';
import { makePaginationObj } from '../../../../helpers/List.helper';

const PaginationComponent = props => {
    const { paginationObj, onClickBtnPageNum } = props;
    return (
        paginationObj ?
            paginationObj.pageList.length > 1 ?
                <div className="pagination">
                    <ul>
                        <li className="">
                            <a onClick={evt => onClickBtnPageNum(paginationObj.firstPageNum)}>{'<<'}</a>
                        </li>
                        <li className="">
                            <a onClick={evt => onClickBtnPageNum(paginationObj.prevPageNum)}>{'<'}</a>
                        </li>
                        {paginationObj.pageList.map((pageNum, idx) =>
                            <li key={idx}
                                className={paginationObj.idxInList === idx ? "on" : ""}>
                                <a onClick={evt => onClickBtnPageNum(pageNum)}>{pageNum}</a>
                            </li>
                        )}
                        <li className="">
                            <a onClick={evt => onClickBtnPageNum(paginationObj.nextPageNum)}>{'>'}</a>
                        </li>
                        <li className="">
                            <a onClick={evt => onClickBtnPageNum(paginationObj.lastPageNum)}>{'>>'}</a>
                        </li>
                    </ul>
                </div>
                : null
            : null
    )
}

export default PaginationComponent;